module.exports = __webpack_public_path__ + "./static/img/news.37a39c0708f72146017a13cc4158ae3d.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/news.png
// module id = ./client/src/assets/fontawesome/news.png
// module chunks = 0